export const HDAACCOUNTS = {
  subway: {
    bgColor: '',
    logo: '/accounts/subway/logo.png',
    alt: 'subway',
  },
  columbuscoffee: {
    bgColor: '',
    logo: '/accounts/columbuscoffee/logo.png',
    alt: 'columbuscoffee',
  },
  redrooster: {
    bgColor: '',
    logo: '/accounts/redrooster/logo.png',
    alt: 'redrooster',
  },
  oporto: {
    bgColor: '',
    logo: '/accounts/oporto/logo.png',
    alt: 'oporto',
  },
  chickentreat: {
    logo: '/accounts/chickentreat/logo.png',
    alt: 'chickentreat',
  },
  hampsta: {
    bgColor: '',
    logo: '/accounts/hampsta/logo.png',
    alt: 'hampsta',
  },
  madbutcher: {
    bgColor: '',
    logo: '/accounts/madbutcher/logo.png',
    alt: 'madbutcher',
  },
  countdown: {
    bgColor: '',
    logo: '/accounts/countdown/logo.png',
    alt: 'countdown',
  },
  paperplus: {
    bgColor: '',
    logo: '/accounts/paperplus/logo.png',
    alt: 'paperplus',
  },
  westfield: {
    bgColor: '',
    logo: '/accounts/westfield/logo.png',
    alt: 'westfield',
  },
  // generic fallback entry
  generic: {
    bgColor: '',
    logo: '/accounts/generic/generic/logo.png',
    alt: 'generic',
  },
  // generic module
  pwa: {
    bgColor: '',
    logo: '/accounts/generic/pwa/logo.png',
    alt: 'pwa',
  },
  palmers: {
    bgColor: '',
    logo: '/accounts/generic/palmers/logo.png',
    alt: 'palmers',
  },
  rollickin: {
    bgColor: '',
    logo: '/accounts/generic/rollickin/logo.png',
    alt: 'rollickin',
  },
  northcity: {
    bgColor: '',
    logo: '/accounts/generic/northcity/logo.png',
    alt: 'northcity',
  },
  avanti: {
    bgColor: '',
    logo: '/accounts/generic/avanti/logo.png',
    alt: 'avanti',
  },
  finewinedelivery: {
    bgColor: '',
    logo: '/accounts/generic/finewinedelivery/logo.png',
    alt: 'finewinedelivery',
  },
  eazy: {
    bgColor: '',
    logo: '/accounts/generic/eazy/logo.png',
    alt: 'eazy',
  },
  thetrusts: {
    bgColor: '',
    logo: '/accounts/generic/thetrusts/logo.png',
    alt: 'thetrusts',
  },
  agh: {
    bgColor: '',
    logo: '/accounts/generic/agh/logo.png',
    alt: 'agh',
  },
  karenwalker: {
    bgColor: '',
    logo: '/accounts/generic/karenwalker/svg.png',
    alt: 'karenwalker',
  },
  coffeeclub: {
    bgColor: '',
    logo: '/accounts/generic/coffeeclub/logo.png',
    alt: 'coffeeclub',
  },
  nourish: {
    bgColor: '',
    logo: '/accounts/generic/nourish/logo.png',
    alt: 'nourish',
  },
  acquisitions: {
    bgColor: '',
    logo: '/accounts/generic/acquisitions/logo.png',
    alt: 'acquisitions',
  },
  huntingandfishingstore: {
    bgColor: '',
    logo: '/accounts/generic/huntingandfishingstore/logo.png',
    alt: 'huntingandfishingstore',
  },
  huntingandfishingcorp: {
    bgColor: '',
    logo: '/accounts/generic/huntingandfishingcorp/logo.png',
    alt: 'huntingandfishingcorp',
  },
  babyfactory: {
    bgColor: '',
    logo: '/accounts/generic/babyfactory/logo.png',
    alt: 'babyfactory',
  },
  tsujiri: {
    bgColor: '',
    logo: '/accounts/generic/tsujiri/logo.png',
    alt: 'tsujiri',
  },
  musicworks: {
    bgColor: '',
    logo: '/accounts/generic/musicworks/logo.png',
    alt: 'musicworks',
  },
  farro: {
    bgColor: '',
    logo: '/accounts/generic/farro/logo.svg',
    alt: 'farro',
  },
  paperplusgift: {
    bgColor: '',
    logo: '/accounts/generic/paperplusgift/logo.png',
    alt: 'paperplusgift',
  },
  britomart: {
    bgColor: '',
    logo: '/accounts/generic/britomart/logo.png',
    alt: 'britomart',
  },
  commercialbay: {
    bgColor: '',
    logo: '/accounts/generic/commercialbay/logo.svg',
    alt: 'commercialbay',
  },
  ponsonbycentral: {
    bgColor: '',
    logo: '/accounts/generic/ponsonbycentral/logo.png',
    alt: 'ponsonbycentral',
  },
  chartwellandqueensgate: {
    bgColor: '',
    logo: '/accounts/generic/chartwellandqueensgate/logo.png',
    alt: 'chartwellandqueensgate',
  },
  lonestar: {
    bgColor: '',
    logo: '/accounts/generic/lonestar/logo.png',
    alt: 'lonestar',
  },
  joesgarage: {
    bgColor: '',
    logo: '/accounts/generic/joesgarage/logo.svg',
    alt: 'joesgarage',
  },
  robertharris: {
    bgColor: '',
    logo: '/accounts/generic/robertharris/logo.png',
    alt: 'robertharris',
  },
  ballantynes: {
    bgColor: '',
    logo: '/accounts/generic/ballantynes/logo.svg',
    alt: 'ballantynes',
  },
  hjsmith: {
    bgColor: '',
    logo: '/accounts/generic/hjsmith/logo.png',
    alt: 'hjsmith',
  },
  skycity: {
    bgColor: '',
    logo: '/accounts/generic/skycity/logo.png',
    alt: 'skycity',
  },
  perfectgift: {
    bgColor: '',
    logo: '/accounts/generic/generic/logo.png',
    alt: 'perfectgift',
  }, //logo image
  testgift: {
    bgColor: '',
    logo: '/accounts/generic/generic/logo.png',
    alt: 'testgift',
  },
  toolshed: {
    bgColor: '',
    logo: '/accounts/generic/toolshed/logo.png',
    alt: 'toolshed',
  },
  duckisland: {
    bgColor: '',
    logo: '/accounts/generic/duckisland/logo.png',
    alt: 'duckisland',
  },
  majesticteabar: {
    bgColor: '',
    logo: '/accounts/generic/majesticteabar/logo.svg',
    alt: 'majesticteabar',
  },
  southcity: {
    bgColor: '',
    logo: '/accounts/generic/southcity/logo.png',
    alt: 'southcity',
  },
  thehubhornby: {
    bgColor: '',
    logo: '/accounts/generic/thehubhornby/logo.png',
    alt: 'thehubhornby',
  },
  nood: {
    bgColor: '',
    logo: '/accounts/generic/nood/logo.png',
    alt: 'nood',
  },
  joylab: {
    bgColor: '',
    logo: '/accounts/generic/generic/logo.png',
    alt: 'joylab',
  }, //logo image
  pattersons: {
    bgColor: '',
    logo: '/accounts/generic/pattersons/logo.png',
    alt: 'pattersons',
  },
  ccbs: {
    bgColor: '',
    logo: '/accounts/generic/ccbs/logo.png',
    alt: 'ccbs',
  },
  avantinz: {
    bgColor: '',
    logo: '/accounts/generic/generic/logo.png',
    alt: 'avantinz',
  }, //logo image
  avantioz: {
    bgColor: '',
    logo: '/accounts/generic/generic/logo.png',
    alt: 'avantioz',
  }, //logo image
  ilt: {
    bgColor: '',
    logo: '/accounts/generic/ilt/logo.png',
    alt: 'ilt',
  },
  westcity: {
    bgColor: '',
    logo: '/accounts/generic/westcity/logo.png',
    alt: 'westcity',
  },
  stpierresushi: {
    bgColor: '',
    logo: '/accounts/generic/stpierresushi/logo.png',
    alt: 'stpierresushi',
  },
  dresssmart: {
    bgColor: '',
    logo: '/accounts/generic/dresssmart/logo.png',
    alt: 'dresssmart',
  },
}

export const HDAACCOUNTSARRAY = [
  {
    project: 'hda_sub',
    bgColor: '',
    logo: '/accounts/subway/logo.png',
    alt: 'subway',
  },
  {
    project: 'hda_col',
    bgColor: '',
    logo: '/accounts/columbuscoffee/logo.png',
    alt: 'columbuscoffee',
  },
  {
    project: 'hda_rr',
    bgColor: '',
    logo: '/accounts/redrooster/logo.png',
    alt: 'redrooster',
  },
  {
    project: 'hda_op',
    bgColor: '',
    logo: '/accounts/oporto/logo.png',
    alt: 'oporto',
  },
  {
    project: 'hda_ct',
    bgColor: '',
    logo: '/accounts/chickentreat/logo.png',
    alt: 'chickentreat',
  },
  {
    project: 'hda_hmp',
    bgColor: '',
    logo: '/accounts/hampsta/logo.png',
    alt: 'hampsta',
  },
  {
    project: 'hda_hmp_mbx',
    bgColor: '',
    logo: '/accounts/madbutcher/logo.png',
    alt: 'madbutcher',
  },
  {
    project: 'hda_cntd',
    bgColor: '',
    logo: '/accounts/countdown/logo.png',
    alt: 'countdown',
  },
  {
    project: 'generic',
    bgColor: '',
    logo: '/accounts/generic/logo.png',
    alt: 'generic',
  },
  {
    project: 'hda_bd',
    bgColor: '',
    logo: '/accounts/paperplus/logo.png',
    alt: 'paperplus',
  },
  {
    project: 'hda_wf',
    bgColor: '',
    logo: '/accounts/westfield/logo.png',
    alt: 'westfield',
  },
  {
    project: 'hda_ll_4',
    bgColor: '',
    logo: '/accounts/generic/pwa/logo.png',
    alt: 'pwa',
  },
  {
    project: 'hda_pl_112',
    bgColor: '',
    logo: '/accounts/generic/palmers/logo.png',
    alt: 'palmers',
  },
  {
    project: 'hda_ro_368',
    bgColor: '',
    logo: '/accounts/generic/rollickin/logo.png',
    alt: 'rollickin',
  },
  {
    project: 'hda_nc_348',
    bgColor: '',
    logo: '/accounts/generic/northcity/logo.png',
    alt: 'northcity',
  },
  {
    project: 'hda_anz_63',
    bgColor: '',
    logo: '/accounts/generic/avanti/logo.png',
    alt: 'avanti',
  },
  {
    project: 'hda_fwdg_363',
    bgColor: '',
    logo: '/accounts/generic/finewinedeliverygift/logo.png',
    alt: 'finewinedeliverygift',
  },
  {
    project: 'hda_eg_103',
    bgColor: '',
    logo: '/accounts/generic/eazy/logo.png',
    alt: 'eazy',
  },
  {
    project: 'hda_tt_206',
    bgColor: '',
    logo: '/accounts/generic/thetrusts/logo.png',
    alt: 'thetrusts',
  },
  {
    project: 'hda_agh_401',
    bgColor: '',
    logo: '/accounts/generic/agh/logo.png',
    alt: 'agh',
  },
  {
    project: 'hda_kw_310',
    bgColor: '',
    logo: '/accounts/generic/karenwalker/logo.svg',
    alt: 'karenwalker',
  },
  {
    project: 'hda_ccg_306',
    bgColor: '',
    logo: '/accounts/generic/coffeeclub/logo.png',
    alt: 'coffeeclub',
  },
  {
    project: 'hda_ng_260',
    bgColor: '',
    logo: '/accounts/generic/nourish/logo.png',
    alt: 'nourish',
  },
  {
    project: 'hda_acq_167',
    bgColor: '',
    logo: '/accounts/generic/acquisitions/logo.png',
    alt: 'acquisitions',
  },
  {
    project: 'hda_hf_307',
    bgColor: '',
    logo: '/accounts/generic/huntingandfishingstore/logo.png',
    alt: 'huntingandfishingstore',
  },
  {
    project: 'hda_hf_308',
    bgColor: '',
    logo: '/accounts/generic/huntingandfishingcorp/logo.png',
    alt: 'huntingandfishingcorp',
  },
  {
    project: 'hda_bf_166',
    bgColor: '',
    logo: '/accounts/generic/babyfactory/logo.png',
    alt: 'babyfactory',
  },
  {
    project: 'hda_tg_429',
    bgColor: '',
    logo: '/accounts/generic/tsujiri/logo.png',
    alt: 'tsujiri',
  },
  {
    project: 'hda_mw_433',
    bgColor: '',
    logo: '/accounts/generic/musicworks/logo.png',
    alt: 'musicworks',
  },
  {
    project: 'hda_ff_221',
    bgColor: '',
    logo: '/accounts/generic/farro/logo.svg',
    alt: 'farro',
  },
  {
    project: 'hda_pp_13',
    bgColor: '',
    logo: '/accounts/generic/paperplusgift/logo.png',
    alt: 'paperplusgift',
  },
  {
    project: 'hda_brt_163',
    bgColor: '',
    logo: '/accounts/generic/britomart/logo.png',
    alt: 'britomart',
  },
  {
    project: 'hda_com_371',
    bgColor: '',
    logo: '/accounts/generic/commercialbay/logo.svg',
    alt: 'commercialbay',
  },
  {
    project: 'hda_pon_421',
    bgColor: '',
    logo: '/accounts/generic/ponsonbycentral/logo.png',
    alt: 'ponsonbycentral',
  },
  {
    project: 'hda_chq_315',
    bgColor: '',
    logo: '/accounts/generic/chartwellandqueensgate/logo.png',
    alt: 'chartwellandqueensgate',
  },
  {
    project: 'hda_lsg_304',
    bgColor: '',
    logo: '/accounts/generic/lonestar/logo.png',
    alt: 'lonestar',
  },
  {
    project: 'hda_jgg_305',
    bgColor: '',
    logo: '/accounts/generic/joesgarage/logo.svg',
    alt: 'joesgarage',
  },
  {
    project: 'hda_rh_274',
    bgColor: '',
    logo: '/accounts/generic/robertharris/logo.png',
    alt: 'robertharris',
  },
  {
    project: 'hda_bgc_7',
    bgColor: '',
    logo: '/accounts/generic/ballantynes/logo.svg',
    alt: 'ballantynes',
  },
  {
    project: 'hda_hjs_25',
    bgColor: '',
    logo: '/accounts/generic/hjsmith/logo.png',
    alt: 'hjsmith',
  },
  {
    project: 'hda_sc_248',
    bgColor: '',
    logo: '/accounts/generic/skycity/logo.png',
    alt: 'skycity',
  },
  {
    project: 'hda_pgp_9',
    bgColor: '',
    logo: '/accounts/generic/generic/logo.png',
    alt: 'perfectgift',
  },
  {
    project: 'hda_tg_309',
    bgColor: '',
    logo: '/accounts/generic/generic/logo.png',
    alt: 'testgift',
  },
  {
    project: 'hda_tsg_351',
    bgColor: '',
    logo: '/accounts/generic/toolshed/logo.png',
    alt: 'toolshed',
  },
  {
    project: 'hda_di_399',
    bgColor: '',
    logo: '/accounts/generic/duckisland/logo.png',
    alt: 'duckisland',
  },
  {
    project: 'hda_mtb_365',
    bgColor: '',
    logo: '/accounts/generic/majesticteabar/logo.svg',
    alt: 'majesticteabar',
  },
  {
    project: 'hda_sc_357',
    bgColor: '',
    logo: '/accounts/generic/southcity/logo.png',
    alt: 'southcity',
  },
  {
    project: 'hda_thh_302',
    bgColor: '',
    logo: '/accounts/generic/thehubhornby/logo.png',
    alt: 'thehubhornby',
  },
  {
    project: 'hda_ng_264',
    bgColor: '',
    logo: '/accounts/generic/nood/logo.png',
    alt: 'nood',
  },
  {
    project: 'hda_jl_352',
    bgColor: '',
    logo: '/accounts/generic/generic/logo.png',
    alt: 'joylab',
  },
  {
    project: 'hda_phg_422',
    bgColor: '',
    logo: '/accounts/generic/pattersons/logo.png',
    alt: 'pattersons',
  },
  {
    project: 'hda_ccb_348',
    bgColor: '',
    logo: '/accounts/generic/ccbs/logo.png',
    alt: 'ccbs',
  },
  {
    project: 'hda_anz_63',
    bgColor: '',
    logo: '/accounts/generic/avanti/logo.png',
    alt: 'avantinz',
  },
  {
    project: 'hda_aoz_64',
    bgColor: '',
    logo: '/accounts/generic/generic/logo.png',
    alt: 'avantioz',
  },
  {
    project: 'hda_ilt_299',
    bgColor: '',
    logo: '/accounts/generic/ilt/logo.png',
    alt: 'ilt',
  },
  {
    project: 'hda_wsc_326',
    bgColor: '',
    logo: '/accounts/generic/westcity/logo.png',
    alt: 'westcity',
  },
  {
    project: 'hda_sp_430',
    bgColor: '',
    logo: '/accounts/generic/stpierresushi/logo.png',
    alt: 'stpierresushi',
  },
  {
    project: 'hda_dsc_435',
    bgColor: '',
    logo: '/accounts/generic/dresssmart/logo.png',
    alt: 'dresssmart',
  },
]
